'use client';

import { Button, SkeletonBar } from '@petsmart-ui/sparky';
import cn from 'classnames';

import { useIsMounted, usePageLayout, useStore } from '@libs/common-next';

import { trackSelectStore } from './analytics';
import { getStoreLocatorDetails } from './store-locator.utils';

import './store-locator.scss';

const FIND_A_STORE_LABEL = 'Find a Store';
const LOADING_STORE_LABEL = 'Loading store';

export function StoreLocator() {
    const { selectedStore, selectedStoreId } = useStore();
    const { isMounted } = useIsMounted();
    const store = selectedStore.data;
    const isStoreLoading = !isMounted || Boolean(selectedStoreId && selectedStore.isPending);
    const { setStoreDrawerOpen } = usePageLayout();
    const { hoursLabel, hoursStatus } = store
        ? getStoreLocatorDetails(store)
        : { hoursLabel: '', hoursStatus: 'unavailable' as const };

    const storeLabel = store?.Name ?? FIND_A_STORE_LABEL;
    const storeName = isStoreLoading ? LOADING_STORE_LABEL : storeLabel;

    const handleClick = () => {
        trackSelectStore(storeName);
        setStoreDrawerOpen({ pageType: 'header', align: 'left', showStoreDetails: true });
    };

    return (
        <div className="header-store-locator">
            <div className="header-store-locator__group">
                <Button
                    variant="link"
                    className="header-store-locator__link"
                    iconName="pin-outline"
                    aria-busy={isStoreLoading}
                    aria-label={storeName}
                    title={storeName}
                    hideText={isStoreLoading}
                    text={storeLabel}
                    onClick={handleClick}
                />
                {isStoreLoading && <SkeletonBar className="header-store-locator__loader" aria-hidden />}
            </div>
            {store && !isStoreLoading && (
                <span
                    className={cn('header-store-locator__hours sparky-c-text-passage', {
                        'header-store-locator__hours--open': hoursStatus === 'open',
                        'header-store-locator__hours--closed': hoursStatus === 'closed',
                    })}
                >
                    {hoursLabel}
                </span>
            )}
        </div>
    );
}
